{
  "name": "lichtblicke-web",
  "version": "0.8.2",
  "engines": {
    "node": "20.12.1",
    "npm": "10.5.0"
  },
  "scripts": {
    "ng": "ng",
    "build:css-variables": "node css-variables-generator.js",
    "build:icons-names-generated": "node icons-name-generator.js",
    "build:theme-generated": "node theme-generator.js",
    "build:translations": "node tools/translations-generator.js",
    "build:theme": "npm run build:icons-names-generated && npm run build:theme-generated && npm run build:css-variables",
    "start": "ng serve",
    "start:prod": "ng serve --port 4455 -c production",
    "serve": "ng serve --host=0.0.0.0.",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "build:mobile": "ng build && npx cap sync",
    "build-prod:mobile": "ng build --configuration production && npx cap sync",
    "cap:generate:icon_splash": "npx @capacitor/assets generate --assetPath src/assets/splash-icon --android --ios",
    "open:android": "node remove-live-reload.js && npm run build:mobile android && npx cap open android",
    "open:ios": "node remove-live-reload.js && npm run build:mobile ios && npx cap open ios",
    "open:live:android": "node live-reload.js && npm run build:mobile android && npx cap open android",
    "open:live:ios": "node live-reload.js && npm run build:mobile ios && npx cap open ios",
    "test": "ng test",
    "format": "prettier --fix --write \"./**/*.{js,jsx,mjs,cjs,ts,tsx,json,scss,html}\"",
    "e2e": "playwright test",
    "build-for-docker": "ng build --configuration production --cross-origi use-credentials --output-path dist",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "fetch-openapispec": "node --env-file=.env --import tsx ./tools/fetchOpenApiSpec.ts --url=https://lichtblicke-dev.hosting.it-objects.de/api/docs/v1/swagger.json --output=./src/api/specs/lb.json",
    "generate-mock": "npx msw-auto-mock ./src/api/specs/lb.json  --output ./src/api/mock/auto-gen --base-url /api",
    "generate-api": "rimraf ./src/api/auto-gen && npx openapi-generator-cli generate -i ./src/api/specs/lb.json -o ./src/api/auto-gen -c ./apiClientGenerator.config.json -g typescript-angular",
    "generate-mock-and-api": "npm run generate-mock & npm run generate-api",
    "generate-mock-and-api-with-fetch": "npm run fetch-openapispec ; npm run generate-mock-and-api"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/schematics": "21.4.0",
    "@angular/animations": "21.2.13",
    "@angular/cdk": "21.2.11",
    "@angular/common": "21.2.13",
    "@angular/compiler": "21.2.13",
    "@angular/core": "21.2.13",
    "@angular/forms": "21.2.13",
    "@angular/material": "21.2.11",
    "@angular/material-moment-adapter": "21.2.11",
    "@angular/platform-browser": "21.2.13",
    "@angular/platform-browser-dynamic": "21.2.13",
    "@angular/router": "21.2.13",
    "@capacitor/android": "8.3.4",
    "@capacitor/angular": "2.0.3",
    "@capacitor/app": "8.1.0",
    "@capacitor/core": "8.3.4",
    "@capacitor/device": "8.0.2",
    "@capacitor/haptics": "8.0.2",
    "@capacitor/ios": "8.3.4",
    "@capacitor/network": "8.0.1",
    "@capacitor/splash-screen": "8.0.1",
    "@capacitor/status-bar": "8.0.2",
    "@material-design-icons/font": "0.14.15",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "capacitor-plugin-safe-area": "5.0.0",
    "cordova-plugin-screen-orientation": "3.0.4",
    "es6-promise-plugin": "4.2.2",
    "globals": "17.6.0",
    "html2pdf.js": "0.14.0",
    "json-logic-js": "2.0.5",
    "luxon": "3.7.2",
    "moment": "2.30.1",
    "ngx-filesaver": "21.0.0",
    "ngx-mat-select-search": "8.0.6",
    "ngx-material-timepicker": "13.1.1",
    "ngx-toastr": "20.0.5",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "underscore": "1.13.8",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^21.2.11",
    "@angular/cli": "21.2.11",
    "@angular/compiler-cli": "21.2.13",
    "@capacitor/cli": "8.3.4",
    "@eslint/js": "9.39.1",
    "@openapitools/openapi-generator-cli": "2.38.0",
    "@playwright/test": "1.60.0",
    "@types/jasmine": "6.0.0",
    "@types/json-logic-js": "2.0.8",
    "@types/underscore": "1.13.0",
    "angular-eslint": "21.4.0",
    "autoprefixer": "10.5.0",
    "dotenv": "17.4.2",
    "eslint": "9.39.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.5",
    "husky": "9.1.7",
    "jasmine-core": "5.1.2",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "postcss": "8.5.15",
    "prettier": "3.8.3",
    "prettier-plugin-organize-imports": "4.3.0",
    "prettier-plugin-tailwindcss": "0.7.2",
    "tailwindcss": "3.4.4",
    "tsx": "4.22.4",
    "typescript": "5.9.3",
    "typescript-eslint": "8.59.4"
  }
}
